import { ITemplateRepository } from '../domain/repositories/ITemplateRepository'
import { Template, TemplateFilters, TemplateListResult } from '../domain/entities/Template'
import { normalizeTemplateStatus } from '../domain/entities/TemplateStatus'
import { toPayloadTemplateDTO, fromApiTemplateDetail } from './adapters/TemplateAdapter'
import { createPattern, getTemplates, getTemplateDetail } from '../../services/templateService'

interface TemplateApiItem {
    id: number
    name: string
    count_groups: number
    count_chutes: number
    warehouse_name?: string
    classification_type_id?: number
    classification_type_key?: string
    classification_type_description?: string
    status_key?: string
    status_name?: string
    rules?: Template['rules']
    created_at?: string
}

export class AxiosTemplateRepository implements ITemplateRepository {
    async getAll(filters: TemplateFilters): Promise<TemplateListResult> {
        const response = await getTemplates(
            filters.page ?? 1,
            filters.name ?? '',
            filters.created_after,
            filters.created_before,
            filters.operationModeId,
            filters.status
        )
        return {
            page: response.page,
            totalItems: response.totalItems,
            totalAllTemplates: response.totalAllTemplates ?? 0,
            size: response.size,
            totalByClassificationType: response.totalByClassificationType,
            items: (response.items ?? []).map((item: TemplateApiItem) => ({
                id: item.id,
                name: item.name,
                countGroups: item.count_groups ?? 0,
                countChutes: item.count_chutes ?? 0,
                warehouseName: item.warehouse_name,
                status: normalizeTemplateStatus(item.status_key),
                statusName: item.status_name,
                operationMode: item.classification_type_key
                    ? {
                          id: item.classification_type_id ?? 0,
                          code: item.classification_type_key,
                          name: item.classification_type_description ?? '',
                      }
                    : undefined,
                rules: item.rules ?? [],
                created_at: item.created_at,
            })),
        }
    }

    async saveTemplate(template: Template): Promise<Template> {
        const payload = toPayloadTemplateDTO(template)
        const response = await createPattern(payload)
        return {
            id: response.data.id,
            name: response.data.name,
            operationMode: template.operationMode,
            status: normalizeTemplateStatus(response.data.status),
            countGroups: response.data.count_groups ?? 0,
            countChutes: response.data.count_chutes ?? 0,
            rules: template.rules,
        }
    }

    async getById(id: number): Promise<Template> {
        const response = await getTemplateDetail(id)
        return fromApiTemplateDetail(response)
    }
}
